export enum Currency {
  Eur = 'EUR',
  Czk = 'CZK',
  Usdc = 'USDC',
  Usdt = 'USDT',
  Chf = 'CHF',
  Pln = 'PLN',
}
